export const AUTH_CONSTS = {
    LOG_IN: "LOG_IN",
    LOG_OUT: "LOG_OUT",
    REFRESH_TOKEN: "REFRESH_TOKEN",
    SET_ACCESS_PAGES: "SET_ACCESS_PAGES",
};
